export default __webpack_public_path__ + "static/media/icon_attachment.3b45817d.svg";